import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import { BiArrowBack } from "react-icons/bi";
import RichTextEditor from "../../components/RichTextEditor/RichTextEditor";

const AddSimulators = () => {
  const { levelId, id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = (queryParams.get("type") ?? "COURSE").toUpperCase();
  const [overview, setOverView] = useState("");
  const [objective, setObjective] = useState("");
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const [loading, setLoading] = useState(false);
  const [loader, setShowLoader] = useState(false);
  const [data, setData] = useState({});
  const [airports, setAirports] = useState<any[]>([]);
  const [error, setError] = useState(false);
  const isEditMode = id !== "add";

  useEffect(() => {
    if (id !== "add") lessonDetails();
    airportList();
  }, []);
  useEffect(() => {
    if (isEditMode && airports.length > 0) {
      setValue("sim_airport_id", (data as any)?.sim_airport_id ?? "");
    }
  }, [airports, data]);

  const airportList = () => {
    setShowLoader(true);
    WebService.getAPI({
      action: `/simulator-airport/list`,
      body: null,
    })
      .then((res: any) => {
        setShowLoader(false);
        const list = res.list || [];
        setAirports(list);
      })
      .catch((e: any) => {
        setShowLoader(false);
        toast.error(e?.response?.data?.message);
      });
  };
  const lessonDetails = () => {
    setLoading(true);

    WebService.getAPI({
      action: `/simulator-lesson/${id}`,
    })
      .then((res: any) => {
        setLoading(false);
        setData(res.result);

        setValue("name", res.result.name);
        setValue("overview", res.result.overview);
        // setValue("objective", res.result.objective);
        setValue("sim_stage", res.result.sim_stage);
        setValue("sim_rule", res.result.sim_rule);
        setValue("sim_airport_id", res.result.sim_airport_id || "");
        setValue("call_sign", res.result.call_sign || "");
        setValue("atis", res.result.atis || "");
        setValue("altitude", res.result.altitude || "");

        setOverView(res.result.overview);
        setObjective(res.result.objective);
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message);
      });
  };
  // ...existing code...
  const onSave = async (form: any) => {
    const payload = {
      uuid: id,
      name: form.name,
      overview: overview,
      // objective: objective,
      sim_stage: form.sim_stage,
      sim_rule: form.sim_rule,
      sim_airport_id: form.sim_airport_id || null,
      call_sign: form.call_sign,
      atis: form.atis,
      altitude: form.altitude,
      learning_mode: "SIMULATOR_SET",
      course_level_id: levelId,
    };

    setShowLoader(true);
    try {
      if (id !== "add") {
        // Update
        const res: any = await WebService.putAPI({
          action: `/simulator-lesson/edit`,
          body: payload,
        });

        toast.success(res.message);
        setShowLoader(false);

        navigate(`/manage-simulators`);
      } else {
        // Add
        const addPayload = {
          name: form.name,
          overview: overview,
          // objective: objective,
          sim_stage: form.sim_stage,
          sim_rule: form.sim_rule,
          sim_airport_id: form.sim_airport_id || null,
          learning_mode: "SIMULATOR_SET",
          call_sign: form.call_sign,
          atis: form.atis,
          altitude: form.altitude,
          course_level_id: levelId,
        };

        const res: any = await WebService.postAPI({
          action: `/simulator-lesson/add`,
          body: addPayload,
        });

        toast.success(res.message || "Simulator added successfully");
        setShowLoader(false);

        navigate(`/manage-simulators`);
      }
    } catch (e: any) {
      setShowLoader(false);
      toast.error(e?.response?.message || "Something went wrong");
      setError(true);
    }
  };
  const SIM_STAGES = [
    { label: "Arrival", value: "ARRIVAL" },
    { label: "Departure", value: "DEPARTURE" },
  ];

  const SIM_RULES = [
    { label: "IFR", value: "IFR" },
    { label: "VFR", value: "VFR" },
  ];

  return (
    <Container className="mt-5">
      {/* BACK BUTTON */}
      <Row className="align-items-center mb-4">
        <Col xs="auto">
          <Link
            to={`/manage-simulators`}
            className="d-flex align-items-center text-decoration-none"
          >
            <BiArrowBack size={22} className="me-2 text-dark" />
            <span className="text-dark">Back</span>
          </Link>
        </Col>

        <Col className="text-center">
          <h1 className="font-20 font-bold m-0">
            {id !== "add" ? "Update Simulator" : "Add Simulator"}
          </h1>
        </Col>

        <Col xs="auto"></Col>
      </Row>

      {/* FORM */}
      <Row className="justify-content-center">
        <Col lg={10}>
          <Loader show={loading} />

          <Card className="p-4 shadow-sm">
            <Form onSubmit={handleSubmit(onSave)}>
              <Row className="mb-3">
                <Col lg={12}>
                  <Form.Group controlId="name">
                    <Form.Label>Simulator Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      {...register("name", { required: true })}
                    />
                  </Form.Group>

                  {errors.name && (
                    <small className="text-danger">Please enter name</small>
                  )}
                </Col>
              </Row>
              {/* Objective */}
              {/* <Row className="mb-3">
                <Col lg={12}>
                  <Form.Group controlId="lessonObjective">
                    <Form.Label column sm={3}>
                      Simulator Objective
                    </Form.Label>
                    <RichTextEditor
                      height="250px"
                      value={objective}
                      onChange={setObjective}
                    />
                  </Form.Group>
                </Col>
              </Row> */}

              {/* Overview */}
              <Row className="mb-3 mt-5">
                <Col lg={12}>
                  <Form.Group controlId="lessonOverview">
                    <Form.Label column sm={3}>
                      Simulator Overview
                    </Form.Label>
                    <RichTextEditor
                      height="250px"
                      value={overview}
                      onChange={setOverView}
                    />
                  </Form.Group>
                </Col>
              </Row>
              {/* <Row className="mt-5">
                <Col lg={12}>
                  <Form.Group controlId="code">
                    <Form.Label>Sim Rule</Form.Label>
                    <Form.Select {...register("sim_rule", { required: true })}>
                      <option value="">Select Rule</option>
                      {SIM_RULES.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row> */}
              <Row className="mt-5">
                <Col lg={12}>
                  <Form.Group controlId="code">
                    <Form.Label>Sim Stage</Form.Label>
                    <Form.Select {...register("sim_stage", { required: true })}>
                      <option value="">Select Stage</option>
                      {SIM_STAGES.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              {/* <Row className="mt-2">
                <Col lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Call Sign</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("call_sign", { required: false })}
                      placeholder="e.g. KLM123"
                    />
                  </Form.Group>
                  {errors.call_sign && (
                    <small className="text-danger">
                      Please enter call sign
                    </small>
                  )}
                </Col>
              </Row> */}

              <Row className="mt-2">
                <Col lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Atis</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("atis", { required: false })}
                      placeholder="Please enter atis"
                    />
                  </Form.Group>
                  {errors.call_sign && (
                    <small className="text-danger">
                      Please enter atis information
                    </small>
                  )}
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Altitude</Form.Label>
                    <Form.Control
                      type="text"
                      {...register("altitude", { required: false })}
                      placeholder="Please enter altitude"
                    />
                  </Form.Group>
                  {errors.altitude && (
                    <small className="text-danger">Please enter altitude</small>
                  )}
                </Col>
              </Row>
              {/* <Row className="mt-5">
                <Col lg={12}>
                  <Form.Group controlId="code">
                    <Form.Label>Sim Airport Code</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Code"
                      {...register("sim_airport_code", { required: false })}
                    />
                  </Form.Group>
                </Col>
              </Row> */}

              <Row className="mb-3 mt-4">
                <Col lg={12}>
                  <Form.Group controlId="courseType">
                    <Form.Label>Sim Airport</Form.Label>
                    <Form.Select
                      {...register("sim_airport_id", { required: false })}
                    >
                      {/* <option value="" disabled>
                        Select Airport
                      </option> */}
                      <option value="">* (Default)</option>
                      {airports.map((x: any) => (
                        <option key={x.id} value={x.id}>
                          {x.name} ({x.code})
                        </option>
                      ))}
                    </Form.Select>

                    {errors.course_id && (
                      <small className="text-danger">
                        Please select a airport
                      </small>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              {/* SAVE / UPDATE BUTTON */}
              <Button
                type="submit"
                className="btn btn-brand-1 d-block mx-auto mt-3"
                disabled={loader}
              >
                {loader && <Spinner size="sm" className="me-2" />}{" "}
                {id !== "add" ? "Update" : "Save"}
              </Button>
            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddSimulators;
